import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DominateYourAcreage from "./sections/DominateYourAcreage";
import TheBeastOfTheBrush from "./sections/TheBeastOfTheBrush";
import LandClearingExpertise from "./sections/LandClearingExpertise";
import RanchOwnerReviews from "./sections/RanchOwnerReviews";
import ClaimYourProperty from "./sections/ClaimYourProperty";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <DominateYourAcreage />
      <TheBeastOfTheBrush />
      <LandClearingExpertise />
      <RanchOwnerReviews />
      <ClaimYourProperty />
      <Footer />
    </div>;
}